import { JsonProperty } from "../../../models/utilities/json-property";
import { ValidateProperty } from "../../../models/utilities/validate-property";
import { ShipmentActionType } from "../enums/shipment-action-type";

export const shipmentActionCreateMapper = (type : any) => {

    // Origin = 0,
    // CustomerDelivery = 1,
    // Backhaul = 2,
    // Destination = 3

    switch (type) {
        case 0: 
            return ShipmentActionCreate;
        case 1:
            return DeliveryShipmentActionCreate;
        case 2:
            return BackhaulShipmentActionCreate;
        case 3:
            return ShipmentActionCreate;
        default:
            return {};
    }

};

export class ShipmentActionCreate {
    
    @ValidateProperty({ required: true })
    public type : ShipmentActionType;

    @JsonProperty({ toType: 'datetime-specific' })
    public stopTimeLocal : Date|null = null;
    
    public travelTime : string|null = null;
    
    public distance : number|null = null;
    
    // FYI: This is the rowVersion of the truck
    public rowVersion : string = '';
    
}

        export class DeliveryShipmentActionCreate extends ShipmentActionCreate {
            
            @ValidateProperty({ required: true })
            public dealerId : string = '';
            
            @ValidateProperty({ required: true })
            public shipToAddressId : number;

            public fixedFreightAmount : number|undefined = undefined;

            @ValidateProperty({ required: true, minChildren: 1 })
            public orders : string[] = [];
        }

        export class BackhaulShipmentActionCreate extends ShipmentActionCreate {

            @ValidateProperty({ required: true })
            public vendorId : string = '';
            
            @ValidateProperty({ required: true })
            public shipToAddressId : number;

        }
